import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import {
  DraftListingPagedApi,
  DraftsListingFiltersApi,
  ProcedureListingPagedApi,
  ProceduresListingFiltersApi,
} from '@core/api/model/my-procedures/procedures-listings-api.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiMyProceduresService {
  /**
   *
   * @param _requestService @see RequestService
   * @param _httpParamsService @see HttpParamsService
   */
  constructor(
    private readonly _requestService: RequestService,
    private readonly _httpParamsService: HttpParamsService
  ) {}

  /**
   * Fetch All Procedures
   */
  public fetchAllProcedures(request: ProceduresListingFiltersApi): Observable<RequestResponse<ProcedureListingPagedApi>> {
    return this._requestService.get<RequestResponse<ProcedureListingPagedApi>>(ApiDirectory.Tramites.AllProcedures({}), {
      params: this._httpParamsService.toParams(request),
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }

  /**
   * Fetch Required Procedures
   */
  public fetchRequiredProcedures(request: ProceduresListingFiltersApi): Observable<RequestResponse<ProcedureListingPagedApi>> {
    return this._requestService.get<RequestResponse<ProcedureListingPagedApi>>(ApiDirectory.Tramites.RequiredProcedures({}), {
      params: this._httpParamsService.toParams(request),
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }

  /**
   * Fetch Pending Procedures
   */
  public fetchPendingProcedures(request: ProceduresListingFiltersApi): Observable<RequestResponse<ProcedureListingPagedApi>> {
    return this._requestService.get<RequestResponse<ProcedureListingPagedApi>>(ApiDirectory.Tramites.PendingProcedures({}), {
      params: this._httpParamsService.toParams(request),
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }

  /**
   * Fetch Closed Procedures
   */
  public fetchClosedProcedures(request: ProceduresListingFiltersApi): Observable<RequestResponse<ProcedureListingPagedApi>> {
    return this._requestService.get<RequestResponse<ProcedureListingPagedApi>>(ApiDirectory.Tramites.ClosedProcedures({}), {
      params: this._httpParamsService.toParams(request),
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }

  /**
   * Fetch Drafts
   */
  public fetchDrafts(request: DraftsListingFiltersApi): Observable<RequestResponse<DraftListingPagedApi>> {
    return this._requestService.get<RequestResponse<DraftListingPagedApi>>(ApiDirectory.Tramites.Drafts({}), {
      params: this._httpParamsService.toParams(request),
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }

  public deleteDraft(draftId: number): Observable<RequestResponse<boolean>> {
    return this._requestService.delete(ApiDirectory.Tramites.EliminarBorrador({ idBorrador: draftId }), {
      loading: LoadingIds.PROCEDURES_LISTING,
    });
  }
}
